import React, { memo } from 'react';
import { PercentLoaderIcon } from '../../assets/icons/PercentLoaderIcon';
import { getMergedClassNames } from '../../utils/HTMLutils';
import IconButton from '../iconButton/IconButton';
import './TableFileNameAndAction.scss';
const rootClassName = 'component-table-file-name-and-action';

export type TableFileName = {
  file?: File;
  name?: string;
  progress?: number;
  indefinido?: boolean;
  uploading?: boolean;
  error?: boolean;
  disabled?: boolean;
};
export interface TableFileNameAndActionProps {
  files: TableFileName[];
  white?: boolean;
  rightIcon?: React.ReactNode;
  onRightIconClick?: (event: number) => void;
  disabledRightIcon?: boolean;
}

function TableFileNameAndAction(props: TableFileNameAndActionProps) {
  return (
    <div className={rootClassName}>
      {props.files && props.files.length
        ? props.files.map((line, index) => {
            const obj = line.file ? line.file : line;
            return (
              <div
                key={index}
                className={getMergedClassNames([
                  `${rootClassName}-file`,
                  props.white ? 'white' : '',
                  line.disabled ? 'disabled' : '',
                  line.error ? 'error' : '',
                ])}
              >
                <span>{obj.name}</span>
                <IconButton
                  icon={
                    line.uploading ? (
                      <PercentLoaderIcon
                        indefinido={line.indefinido}
                        value={String(line.progress)}
                      />
                    ) : (
                      props.rightIcon
                    )
                  }
                  disabled={props.disabledRightIcon || line.disabled || false}
                  onClick={() => {
                    if (typeof props.onRightIconClick === 'function') {
                      props.onRightIconClick(index);
                    }
                  }}
                />
              </div>
            );
          })
        : undefined}
    </div>
  );
}

TableFileNameAndAction.defaultProps = {};

export default memo(TableFileNameAndAction);
